import { render, staticRenderFns } from "./TypeOneIntro.vue?vue&type=template&id=20b58c20"
import script from "./TypeOneIntro.vue?vue&type=script&lang=ts"
export * from "./TypeOneIntro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports